const baseFontSize = '16px'
const containerWidth = {
  sm: '540px',
  m: '720px',
  l: '960px',
  xl: '1360px',
}

export {
	containerWidth,
	baseFontSize
}
